import React from 'react';

import {
  SkeletonProfileImage,
  SkeletonImage,
  SkeletonHeadline,
  SkeletonButton,
} from '@xingternal/skeleton';
import { GridContainer, Row, Column } from '@xingternal/xing-grid';

import styles from './HeaderSkeleton.css';

const HeaderSkeleton = () => (
  <div className={styles.headerSkeleton}>
    <div className={styles.cover}>
      <SkeletonImage variant="secondary" className={styles.coverSkeleton} />
    </div>
    <GridContainer className={styles.grid}>
      <Row>
        <Column size={12} className={styles.mainArea}>
          <div className={styles.logoArea}>
            <SkeletonProfileImage size="xxlarge" />
          </div>
          <div className={styles.sideArea}>
            <div className={styles.primaryArea}>
              <SkeletonHeadline
                variant="primary"
                size="medium"
                amountRows={1}
                className={styles.title}
              />
            </div>
            <div className={styles.secondaryArea}>
              <SkeletonHeadline
                variant="primary"
                size="small"
                amountRows={1}
                className={styles.headlineSecondary}
              />
              <div className={styles.actions}>
                <SkeletonButton
                  variant="primary"
                  size="medium"
                  className={styles.follow}
                />
                <SkeletonButton
                  variant="primary"
                  size="medium"
                  className={styles.more}
                />
              </div>
            </div>
          </div>
        </Column>
      </Row>
    </GridContainer>
  </div>
);

export default HeaderSkeleton;
